import { SideCursive } from './SideCursive';

export default SideCursive;
